<template>
  <div>
    <a :class="className" @click.prevent="showModal" href="#">
      {{ 'Delete' | translate }}
    </a>

    <form ref="delete-form" :action="url" method="POST" style="display: none">
      <input type="hidden" :value="csrf" name="_token" />
      <input type="hidden" name="_method" value="DELETE" />
    </form>

    <!-- Bootstrap Modal -->
    <div ref="modal" class="modal fade" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('Are you sure?') }}</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <p>{{ $t('Do you realy want to delete this element?') }}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="hideModal">{{ $t('Cancel') }}</button>
            <button type="button" class="btn btn-danger" @click="confirmDelete">{{ $t('Delete') }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['className', 'course'],
  data() {
    return {
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      modalInstance: null,
    }
  },
  mounted() {
    // Assumes Bootstrap 5 is loaded globally
    this.modalInstance = new window.bootstrap.Modal(this.$refs.modal, {
      backdrop: 'static',
      keyboard: false,
    })
  },
  methods: {
    showModal() {
      this.modalInstance.show()
    },
    hideModal() {
      this.modalInstance.hide()
    },
    confirmDelete() {
      this.hideModal()
      this.$refs['delete-form'].submit()
    },
  },
  computed: {
    url() {
      if (this.course) {
        return `/home/courses/${this.course.id}`
      }
    },
  },
}
</script>
